import React, { FunctionComponent } from 'react'
import { Image, ImageProps, ImageStyle, StyleProp } from 'react-native'

const SIZES = {
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  '12': 48,
  '16': 64,
  '20': 80,
}

interface ThumbnailProps extends Omit<ImageProps, 'style'> {
  square?: boolean
  small?: boolean
  large?: boolean
  style?: StyleProp<ImageStyle>
}

export const Thumbnail: FunctionComponent<ThumbnailProps> = ({ square, small, large, style, ...props }) => {
  let size = SIZES.md

  if (square && small) size = SIZES['12']
  else if (square && large) size = SIZES['20']
  else if (square) size = SIZES['16']
  else if (!square && small) size = SIZES.xs
  else if (!square && large) size = SIZES.lg

  return (
    <Image
      style={[
        {
          width: size,
          height: size,
          borderRadius: square ? 0 : size / 2,
        },
        style as ImageProps['style'],
      ]}
      resizeMode="cover"
      {...props}
    />
  )
}
